function InputTypeSubmit({value}) {
    return ( 
        <input type="submit" value={value} class="btn"/>
        
     );
}

export default InputTypeSubmit;